import { render, staticRenderFns } from "./CodeGenerate.vue?vue&type=template&id=74a5aef2&scoped=true"
import script from "./CodeGenerate.vue?vue&type=script&lang=js"
export * from "./CodeGenerate.vue?vue&type=script&lang=js"
import style0 from "./CodeGenerate.vue?vue&type=style&index=0&id=74a5aef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5aef2",
  null
  
)

export default component.exports